import { CountryIndicator } from "@domain/currentProfile/countriesIndicators";
import { CountryCode } from "@domain/currentProfile/countryCode";
import { Media } from "@domain/media/media";
import { AreaExpertise } from "./areaExpertise";

export const allIdentityType = ["ID", "PASSPORT"] as const;
export type IdentityType = (typeof allIdentityType)[number];

export const allUserKycType = ["PROFESSIONAL", "TEACHER"] as const;
export type TypeUserKyc = (typeof allUserKycType)[number];

export interface Identity {
	typePassport: IdentityType;
	idPassportId: string;
	idPassportAsset?: Media;
}

interface ProfessionalType {
	typeKyc: "PROFESSIONAL";
	areaExpertise: AreaExpertise;
}
interface ProfessorType {
	typeKyc: "TEACHER";
	matricule: string;
}

export type UserKycType = ProfessionalType | ProfessorType;

export interface UserKyc {
	id: string;
	firstName: string;
	lastName: string;
	phoneNumber: string;
	indicative: CountryIndicator;
	email: string;
	address: string;
	countryResidence: CountryCode;
	type: UserKycType;
	identity: Identity;
	isVerified: boolean;
}
